import { toast } from "react-hot-toast";

export const errorBlock = (err) => {
  if (err?.response) {
    toast.error(err.response?.data?.response);
  } else {
    toast.error(err.message);
  }
};
